module.exports = __webpack_public_path__ + "static/media/login-vb-shield-text-small.810538e5.png";